// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".method-toggle svg{position:absolute;left:25px;bottom:0;top:0;height:60px}@media(max-width:375px){.method-toggle svg{left:20px}}.method-toggle .icon-delivery{width:39px}.method-toggle .icon-pickup{width:37px}.method-toggle button:not(.active) svg path{fill:#979899}@media(max-width:375px){.method-toggle button:first-of-type{padding-right:5px!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
